<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Import Data</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="import data" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>Sheet Name</label>
                <select v-model="sheetName">
                    <option value="">Select Sheet</option>
                    <option v-for="sheet in worksheets" :key="sheet" :value="sheet">
                        {{ sheet }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Model Name</label>
                <select v-model="selectedModelName">
                    <option value="">Select Model</option>
                    <option v-for="model in props.models" :key="model.id" :value="model.name">
                        {{ model.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Table Name</label>
                <select v-model="tableName">
                    <option value="">Select Table</option>
                    <option v-for="table in tables" :key="table.name" :value="table.name">
                        {{ table.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Upsert or Replace</label>
                <select v-model="upsertOrReplace">
                    <option value="Upsert">Upsert</option>
                    <option value="Replace">Replace</option>
                </select>
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, watch, onMounted } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createImportDataWorkflowItem } from '../utils/workflowUtils';
import { tableList } from '../services/optilogicService';
import { useWorksheetSelection } from '../composables/useWorksheetSelection';

const props = defineProps({
    models: Array,
    selectedModel: Object
});

const actionName = ref('');
const sheetName = ref('');
const selectedModelName = ref('');
const tableName = ref('');
const upsertOrReplace = ref('Upsert');
const tables = ref([]);

// Use composable for worksheet selection
const { worksheets } = useWorksheetSelection();

// Function to fetch table list when model changes
const fetchTableList = async (modelId) => {
    if (modelId) {
        const tableData = await tableList(modelId);
        tables.value = tableData;
    } else {
        tables.value = [];
    }
};

// Watch for model changes
watch(selectedModelName, async (newModelName) => {
    if (newModelName) {
        // Find the model by name to get its ID for the API call
        const model = props.models.find(m => m.name === newModelName);
        if (model) {
            await fetchTableList(model.id);
        }
    }
});

// Initialize on mount
onMounted(async () => {
    // Set initial model if selectedModel prop is provided
    if (props.selectedModel) {
        selectedModelName.value = props.selectedModel.name;
    }
});

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createImportDataWorkflowItem(
        actionName.value,
        sheetName.value,
        selectedModelName.value,
        tableName.value,
        upsertOrReplace.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
